import { Component } from 'preact'
import axios from 'axios'
import Phrase from 'libs/translationsUtils/phrase'
import UserAvatar from '../User/UserAvatar'
import Analytics from '../analytics/Analytics'

const gaEventTracker = () => (
  Analytics.send({
    eventCategory: 'Homepage',
    eventAction: 'Recently active user clicked'
  })
)

class LastVisitors extends Component {
  constructor () {
    super()

    this.state = {
      visitors: []
    }
  }
  componentDidMount () {
    axios.get('/widget/lastVisitors')
      .then(res => {
        const newData = res.data.map((visitor) => {
          visitor.id = visitor.userid
          visitor.name = visitor.username
          return visitor
        })
        this.setState({ visitors: newData })
      })
      .catch((e) => {
        console.log('Err ', e)
      })
  }

  render (props, state) {
    if (!state.visitors.length) {
      return null
    }
    return (
      <div className='widget-last-visitors'>
        <div className='widget-title'>
          <Phrase p='branded.last-visitors.title' />
        </div>
        {
          state.visitors.map(visitor => (
            <span className='last-visitor' onClick={gaEventTracker}>
              <UserAvatar
                showRank={false}
                user={visitor}
                extraClass='avatar--S'
              />
            </span>
          ))
        }
      </div>
    )
  }
}

export default LastVisitors
